import { AuthServices } from "./services";
import { AuthConstants } from "./constants";
import { LOGIN_TYPES } from "../../../Config";
import { STORAGE_ITEMS } from "../../../Config/storage";

//TODO тут есть refreshtoken
export const AuthActions = {
  startLogin,
  checkSca,
  selectIdentification,
  reset,
  getIdentificationUrl,
  refreshToken
};

function startLogin(loginData) {
  return dispatch => {
    dispatch(request());

    return AuthServices.startLogin(loginData).then(
      data => {
        dispatch(success(data));
        if (loginData.authType === LOGIN_TYPES.BIO_FACE) {
          dispatch({ type: AuthConstants.BIOFACE_LOGIN_SIDE_EFFECTS });
          localStorage.setItem(STORAGE_ITEMS.LOGIN_TOKEN, data.token);
          localStorage.setItem(STORAGE_ITEMS.SCA_TIMEOUT, data.scaTimeout);
          window.location = data.redirectUrl;
        }
      },
      error => {
        dispatch(failure(error));
        throw error;
      }
    );
  };

  function request() {
    return { type: AuthConstants.START_LOGIN_REQUEST };
  }

  function success(data) {
    return { type: AuthConstants.START_LOGIN_SUCCESS, payload: data };
  }

  function failure(error) {
    return { type: AuthConstants.START_LOGIN_ERROR, error };
  }
}

function checkSca(isWaitingRoom = false) {
  return dispatch => {
    dispatch(request());

    return AuthServices.checkSca(isWaitingRoom).then(
      data => dispatch(success(data)),
      error => {
        dispatch(failure(error));
        throw error;
      }
    );
  };

  function request() {
    return { type: AuthConstants.CHECK_SCA_REQUEST };
  }

  function success(data) {
    return { type: AuthConstants.CHECK_SCA_SUCCESS, payload: data };
  }

  function failure(error) {
    return { type: AuthConstants.CHECK_SCA_ERROR, error };
  }
}

function selectIdentification(data) {
  return dispatch => {
    dispatch(request());

    return AuthServices.selectIdentification(data).then(
      data => dispatch(success(data)),
      error => dispatch(failure(error))
    );
  };

  function request() {
    return { type: AuthConstants.SELECT_IDENTIFICATION_REQUEST };
  }

  function success(data) {
    return { type: AuthConstants.SELECT_IDENTIFICATION_SUCCESS, payload: data };
  }

  function failure(error) {
    return { type: AuthConstants.SELECT_IDENTIFICATION_ERROR, error };
  }
}

function reset() {
  return dispatch => {
    dispatch({ type: AuthConstants.RESET_LOGIN });
  };
}

function getIdentificationUrl(language) {
  return dispatch => {
    dispatch(request());

    return AuthServices.getIdentificationUrl(language).then(
      data => dispatch(success(data)),
      error => dispatch(failure(error))
    );
  };

  function request() {
    return { type: AuthConstants.GET_IDENTIFICATION_URL_REQUEST };
  }

  function success(data) {
    return { type: AuthConstants.GET_IDENTIFICATION_URL_SUCCESS, payload: data };
  }

  function failure(error) {
    return { type: AuthConstants.GET_IDENTIFICATION_URL_ERROR, error };
  }
}

function refreshToken(token) {
  return dispatch => {
    dispatch(request());

    return AuthServices.refreshToken(token).then(
      data => dispatch(success(data)),
      error => dispatch(failure(error))
    );
  };

  function request() {
    return { type: AuthConstants.REFRESH_TOKEN_REQUEST };
  }

  function success(data) {
    return { type: AuthConstants.REFRESH_TOKEN_SUCCESS, payload: data };
  }

  function failure(error) {
    return { type: AuthConstants.REFRESH_TOKEN_ERROR, error };
  }
}
